import { supabase } from './supabase'
import { verifyCapacitySnapshot } from './capacityContract.mjs'

export async function readCapacity(workshopId) {
  const controller = new AbortController()
  const timer = setTimeout(() => controller.abort(), 20000)
  try {
    const { data: { session } } = await supabase.auth.getSession()
    const response = await fetch('/.netlify/functions/capacity-delays', { method: 'POST', signal: controller.signal,
      headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${session?.access_token || ''}` },
      body: JSON.stringify({ workshop_id: workshopId }) })
    if (!response.ok || !/^application\/json\b/i.test(response.headers.get('content-type') || '')) throw new Error()
    const body = await response.text()
    if (new Blob([body]).size > 4 * 1024 * 1024) throw new Error()
    return verifyCapacitySnapshot(JSON.parse(body).data, workshopId)
  } catch { throw new Error('The complete capacity report is unavailable. Try again or contact support. No partial figures are shown.') }
  finally { clearTimeout(timer) }
}
